import { useEffect } from 'react';
import FormService from '../services/form-service';
import { TIMEOUT_DEFAULT } from '../constants/system/timeouts';

const useServerFormErrors: Function = (serverFormErrors: ReactEventListener, onError: () => void): void => {
  useEffect((): void => {
    if (serverFormErrors && Object.keys(serverFormErrors).length) {
      setTimeout((): void => {
        if (onError) {
          onError();
        }

        FormService.focusOnFirstFormError();
      }, TIMEOUT_DEFAULT);
    }
  }, [serverFormErrors]);
};

export default useServerFormErrors;
